import { Chip, ListItemButton, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { RouterLink } from "lib/routes/router-link"
import Iconify from "minimals-template/components/Iconify"
import {
    getProjectBridgeCanonicalUsagePath,
    getProjectBridgeCanonicalUsageRelationshipLabel,
} from "./project-bridge-rewrite-card-presenters"

export function ProjectBridgeCanonicalUsagePopoverItem({ item }) {
    const path = getProjectBridgeCanonicalUsagePath(item)
    const linkProps = buildLinkProps()

    return (
        <ListItemButton
            dense
            selected={Boolean(item?.isCurrentChange)}
            disabled={Boolean(item?.isCurrentChange)}
            sx={{ borderRadius: 1, alignItems: "flex-start" }}
            {...linkProps}
        >
            <Stack direction="row" spacing={1} sx={{ width: "100%", minWidth: 0 }} alignItems="flex-start">
                <Iconify icon="mdi:file-document-outline" sx={{ mt: 0.25, color: "text.secondary" }} />
                <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                        <Typography variant="body2" noWrap>
                            {buildScheduleLabel()}
                        </Typography>
                        <If truthy={item?.isCurrentChange}>
                            <Chip size="small" label="Current" color="primary" variant="outlined" />
                        </If>
                    </Stack>
                    <Typography variant="caption" color="text.secondary" noWrap>
                        {item?.label || "Task"}
                    </Typography>
                    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flexWrap: "wrap", rowGap: 0.5 }}>
                        <Chip
                            size="small"
                            label={getProjectBridgeCanonicalUsageRelationshipLabel(item)}
                            variant="outlined"
                        />
                        <If truthy={item?.decision}>
                            <Chip size="small" label={item?.decision} variant="outlined" />
                        </If>
                    </Stack>
                </Stack>
            </Stack>
        </ListItemButton>
    )

    function buildLinkProps() {
        if (!path || item?.isCurrentChange) return {}
        return {
            component: RouterLink,
            to: path,
        }
    }

    function buildScheduleLabel() {
        const code = `${item?.scheduleCode || ""}`.trim()
        const title = `${item?.scheduleTitle || ""}`.trim()
        if (code && title) return `${code} - ${title}`
        return code || title || "Project Bridge schedule"
    }
}
